import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Tabs } from 'antd';
import { tabRoutes } from 'routes';

import s from './style/TabHeader.pcss';
import { isSupervisorUser } from '../../Auth/redux/auth.redux';


const TabPane = Tabs.TabPane;

@withRouter
@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class TabHeader extends React.Component {
  static propTypes = {
    match: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
    isSupervisor: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    // hack for ant tab-ink-bar
    // need update position after mount component
    setTimeout(() => this.forceUpdate(), 1000);
  }

  changeTab = tab => this.props.history.push(tabRoutes[tab]);

  render() {
    const { isSupervisor, match } = this.props;
    const activeLink = match.params.page;
    // todo: set tab widths by design in zeplin
    return (
      <div className={s.container}>
        <Tabs activeKey={activeLink} onTabClick={this.changeTab}>
          <TabPane tab="Доступ к разделам" key="sections" />
          {!isSupervisor && <TabPane tab="Права и роли" key="roles" />}
          <TabPane tab="Пользователи" key="users" />
          <TabPane tab="Группы" key="groups" />
          {/* !isSupervisor && <TabPane tab="Ключевые слова" key="tags" /> */}
          <TabPane tab="Рассылки" key="notifications" />
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/Main/TabHeader.js